<template>
    <div>
        <b-modal id="newsize-add" title="Add a new banner size" :hide-footer="hideFooter">
            <form action="#" method="POST">
                <div class="form-group">
                    <label for="#sizeName">New Size Name:</label>
                    <input class="form-control" type="text" id="sizeName" placeholder="Ex: 999 x 200 (Leaderboard)" required="required" v-model="sizename">
                </div>
                <div class="form-group">
                    <label for="#sizeCode">New Size Code:</label>
                    <input class="form-control" type="text" id="sizeCode" placeholder="Ex: 999x200" required v-model="sizevalue">
                </div>
                <div class="form-group">
                    <label for="#sizeGroup">New Size Group:</label>
                    <select class="form-control" id="sizeGroup" v-model="sizegroup">
                      <option value="0">Select</option>
                      <option value="desktop">Desktop</option>
                      <option value="mobile">Mobile</option>
                    </select>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveNewSize">Save</button>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Bus } from '@/main'
export default {
  methods: {
    saveNewSize () {
      if (this.sizename && this.sizevalue && this.sizegroup) {
        this.$http.post(`${this.$api_url}/sizes/create`, { sizename: this.sizename, sizevalue: this.sizevalue, sizegroup: this.sizegroup }).then((success, error) => {
          if (success) {
            Bus.$emit('reloadBannerSizes', success.data)
            this.$bvModal.hide('newsize-add')
            this.sizevalue = ''
            this.sizegroup = ''
            this.sizename = ''
          }
          if (error) {
            this.$bvModal.hide('newsize-add')
            alert('Duplicate banner size')
          }
        })
      }
    }
  },
  data () {
    return {
      sizename: '',
      sizevalue: '',
      sizegroup: 0,
      hideFooter: true
    }
  }
}
</script>
<style scoped>

</style>
